import R from 'app/assets/R'
import { BaseCol } from 'app/components/common/BaseCol'
import { BaseSpace } from 'app/components/common/BaseSpace'
import { SectionBase } from 'app/components/common/SectionBase'
import HeaderPage from 'app/components/header/components/HeaderPage'
import { BaseTableManagement } from 'app/components/tables/BaseTableManagement'
import React from 'react'
import { FilterLayout, SyncFromUehModal } from './components'
import { useHook } from './hook'
import * as S from './styles'
import BaseText from 'app/components/common/BaseText'

const HrmTradeUnionMemberManagement: React.FC = () => {
  const {
    columns,
    pagination,
    filter,
    onChangeFilter,
    handleChangePagination,
    isLoading,
    data,
    isPermissionSyncFromUeh,
    downloadExcel,
    isPermissionExportExcelFromUeh
  } = useHook()

  return (
    <S.ScrollWrapper>
      <HeaderPage
        titleI18nKey={R.strings.hrm_trade_union_members_management}
        isExport={isPermissionExportExcelFromUeh}
        onPressExport={downloadExcel}
        rightComponent={
          isPermissionSyncFromUeh ? (
            <BaseCol>
              <SyncFromUehModal />
            </BaseCol>
          ) : undefined
        }
      />

      <SectionBase>
        <BaseSpace size={0}>
          <FilterLayout filter={filter} onChangeFilter={onChangeFilter} />
          <BaseTableManagement
            columns={columns}
            dataSource={data}
            pagination={{
              ...pagination,
              total: pagination.total,
              showTotal: total => (
                <BaseText children={`Tổng: ${total}`} fontWeight="bold" />
              ),
              showSizeChanger: true,
            }}
            loading={isLoading}
            onChange={handleChangePagination}
            rowClassName="row-overwrite-style"
          />
        </BaseSpace>
      </SectionBase>
    </S.ScrollWrapper>
  )
}

export default HrmTradeUnionMemberManagement
